import { createContext, useContext, useMemo } from 'react';
import { useIdOrProvided } from './use-id-or-provided.js';

const IdContext = createContext('');
function useIdProvider(idIn) {
    const id = useIdOrProvided(idIn);
    return useMemo(() => [id, IdContext.Provider], [id]);
}
function useProvidedId(idIn) {
    const providedId = useContext(IdContext);
    return idIn ?? providedId;
}
function getDescriptionId(id) {
    return `${id}-desc`;
}

export { getDescriptionId, useIdProvider, useProvidedId };
//# sourceMappingURL=id-provider.js.map
